import { mount } from "svelte";
import AddUsersModal from "../pages/Admin/AddUserModal/AddUsersModal.svelte";
import AssignLicenseModal from "../pages/Admin/AssignLicenseModal/AssignLicenseModal.svelte";
import InboxAgentPage from "../pages/Admin/InboxAgentPage.svelte";
import LicensePage from "../pages/Admin/LicensePage.svelte";
import NotetakerPage from "../pages/Admin/NotetakerPage.svelte";
import EmailLimits from "../pages/Admin/Settings/EmailLimits.svelte";

export const bindLicenseComponents = () => {
  mount(LicensePage, {
    target: document.getElementById("licensesTableContainer"),
    props: {},
  });
  mount(AddUsersModal, {
    target: document.getElementById("modularizedAddUsersModal"),
    props: {},
  });
  mount(AssignLicenseModal, {
    target: document.getElementById("assignLicenseModal"),
    props: {},
  });
};

export const bindSettingsComponents = () => {
  mount(EmailLimits, {
    target: document.getElementById("emailLimitsContainer"),
    props: {},
  });
  mount(NotetakerPage, {
    target: document.getElementById("notetakerSettingsContainer"),
    props: {},
  });
  mount(InboxAgentPage, {
    target: document.getElementById("inboxAgentSettingsContainer"),
    props: {},
  });
};
